import styled from 'styled-components/native';

import Button from 'components/Button';

export default styled(Button).attrs({
  primary: true,
})`
  margin: 25px 0 0 0;
`;
